import { debounce } from 'debounce';
import { equals } from 'ramda';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getCountersSum, simpleRequestCounters } from '../../../../common/helpers/refCountersHelper';
import { IBindingCallback1 } from '../../../../common/models/callback';
import { IRefReqCounters } from '../../../../common/models/referenceRequest/IRefReqCounters';
import { IAppState } from '../../../../common/models/store/IAppState';
import LoaderWrapper from '../../../../components/LoaderWrapper';
import RefReqCounters from '../../../../components/RefReqCounters';
import { updateDefaultCountersRoutine } from '../../routines';

interface IProps {
  defaultCounters: IRefReqCounters;
  isSaving: boolean;
  updateDefaultCounters: IBindingCallback1<IRefReqCounters>;
}

interface ICountersData {
  isAdvanced: boolean;
  defaultCounters: IRefReqCounters;
  counters: IRefReqCounters
}

const DefaultCountersPane: FunctionComponent<IProps> = ({
  defaultCounters, isSaving, updateDefaultCounters
}) => {
  const [counters, setCounters] = useState(defaultCounters);
  const isDefaultAdvanced = Boolean(getCountersSum(counters));
  const [isAdvanced, setIsAdvanced] = useState(isDefaultAdvanced);

  const onUpdateCounters = (data: ICountersData) => {
    const countersToSave = data.isAdvanced
      ? data.counters
      : { ...simpleRequestCounters, totalCount: data.counters.totalCount };
    const shouldUpdate = !equals(countersToSave, defaultCounters);

    if (shouldUpdate) {
      updateDefaultCounters(countersToSave);
    }
  };

  const update = debounce((data: ICountersData) => onUpdateCounters(data), 400);

  useEffect(() => {
    update({ counters, defaultCounters, isAdvanced });
    return () => update.clear();
  }, [counters]);

  useEffect(() => {
    onUpdateCounters({ counters, defaultCounters, isAdvanced });
  }, [isAdvanced]);

  return (
    <div className="position-relative">
      <LoaderWrapper loading={isSaving} transparent>
        <RefReqCounters
          refCounters={counters}
          isAdvanced={isAdvanced}
          changeCounters={setCounters}
          toggleAdvancedReq={setIsAdvanced}
        />
      </LoaderWrapper>
    </div>
  );
};

const mapStateToProps = ({
  workspace: { defaultCounters },
  settings: { isSaving }
}: IAppState) => ({ defaultCounters: defaultCounters as IRefReqCounters, isSaving });

const mapDispachToProps = {
  updateDefaultCounters: updateDefaultCountersRoutine
};

export default connect(mapStateToProps, mapDispachToProps)(DefaultCountersPane);
